import * as React from "react";
import { Typography, Grid, Box, useMediaQuery, useTheme } from "@mui/material";
import "./lotterySystem.css";
import increaseSales from '../common/svgs/increaseSales.svg';
import lotteryDisplayManagementNew from "../common/svgs/feature-1-latest.svg";
import quickService from '../common/svgs/quickService.svg';
import listIcon from '../common/svgs/listIcon.svg';
import { useTranslation } from 'react-i18next';

const Features: React.FC = () => {
  const { t } = useTranslation('translation');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Below 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600px - 1024px

  return (
    <Box sx={{ px: isMobile ? 2 : 4, py: 4 }}>
      <Typography
        className="landing-section-heading landing-headers-orange-color"
        variant="h5"
        align="center"
        sx={{ fontSize: isMobile ? "1.8rem" : isTablet ? "2rem" : "2.5rem" }}
      >
        {t("features")}
      </Typography>
      <Typography
        className="landing-feature-description-typo"
        align="center"
        sx={{ fontSize: isMobile ? "1rem" : "1.2rem", mt: 1 }}
      >
        Start working with <span className="landing-feature-color">Digi Tech Express</span> that can provide everything you need.
      </Typography>

      {/* Feature: Lottery Display Management */}
      <Grid container spacing={4} alignItems="center" className="landing-feature-margin">
        <Grid item xs={12} md={6} className="landing-feature-content-image" textAlign="center" order={isMobile ? 1 : 0}>
          <img
            src={lotteryDisplayManagementNew}
            alt="lottery display management"
            style={{
              width: isMobile ? "90%" : isTablet ? "80%" : "100%",
              maxWidth: "500px",
              height: "auto",
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} textAlign={isMobile ? "center" : "left"}>
          <Typography className="landing-feature-content-title landing-secondary-color">
            {t('lotteryDisplayManagementTitle')}
          </Typography>
          <Typography className="landing-feature-content-description landing-text-color">
            {t('lotteryDisplayManagementDescription')}
          </Typography>
          {Array(3).fill("").map((_, index) => (
            <Grid key={index} display="flex" alignItems="center" mt="1%" justifyContent={isMobile ? "flex-start" : "flex-start"}>
              <img className="landing-feature-content-list-icon" src={listIcon} alt="" />
              <Typography className="landing-feature-content-description landing-text-color">
                {t(`lotteryDisplayManagementList${index + 1}`)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Feature: Increase Sales */}
      <Grid container spacing={4} alignItems="center" className="landing-feature-margin">
        <Grid item xs={12} md={6} textAlign={isMobile ? "center" : "left"}>
          <Typography className="landing-feature-content-title landing-secondary-color">
            {t('increaseSalesTitle')}
          </Typography>
          <Typography className="landing-feature-content-description landing-text-color">
            {t('increaseSalesDescription')}
          </Typography>
          {Array(3).fill("").map((_, index) => (
            <Grid key={index} display="flex" alignItems="center" mt="1%" justifyContent={isMobile ? "flex-start" : "flex-start"}>
              <img className="landing-feature-content-list-icon" src={listIcon} alt="" />
              <Typography className="landing-feature-content-description landing-text-color">
                {t(`increaseSalesList${index + 1}`)}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12} md={6} className="landing-feature-content-image" textAlign="center" order={isMobile ? -1 : 0}>
          <img
            src={increaseSales}
            alt="increase sales"
            style={{
              width: isMobile ? "90%" : isTablet ? "80%" : "100%",
              maxWidth: "500px",
              height: "auto",
            }}
          />
        </Grid>
      </Grid>

      {/* Feature: Quick Service */}
      <Grid container spacing={4} alignItems="center" className="landing-feature-margin">
        <Grid item xs={12} md={6} className="landing-feature-content-image" textAlign="center">
          <img
            src={quickService}
            alt="quick service"
            style={{
              width: isMobile ? "80%" : isTablet ? "70%" : "100%",
              maxWidth: "400px",
              height: "auto",
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} textAlign={isMobile ? "center" : "left"}>
          <Typography className="landing-feature-content-title landing-secondary-color">
            {t('quickServiceTitle')}
          </Typography>
          <Typography className="landing-feature-content-description landing-text-color">
            {t('quickServiceDescription')}
          </Typography>
          {Array(3).fill("").map((_, index) => (
            <Grid key={index} display="flex" alignItems="center" mt="1%" justifyContent={isMobile ? "flex-start" : "flex-start"}>
              <img className="landing-feature-content-list-icon" src={listIcon} alt="" />
              <Typography className="landing-feature-content-description landing-text-color">
                {t(`quickServiceList${index + 1}`)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Typography className="landing-feature-footer-content landing-text-color" align="center" sx={{ mt: 4 }}>
        {t('lotteryDisplayManagementFooterDescription')}
      </Typography>
    </Box>
  );
};

export default Features;
